// Icone line-art degli elementi decorativi: SVG inline, nessun DOM.
// Tratto uniforme 1.5, viewBox 24, stroke currentColor.

export const ELEMENT_ICONS = {
  cross: '<path d="M12 4v16M7 9h10"/>',
  angel:
    '<circle cx="12" cy="5.5" r="2"/><path d="M12 9v6l-2.5 5h5L12 15"/><path d="M10 10.5C6.5 10 4.5 7.5 4 5c2.5.5 5 2 6 4.5"/><path d="M14 10.5c3.5-.5 5.5-3 6-5.5-2.5.5-5 2-6 4.5"/>',
  mary:
    '<path d="M12 3c-3.5 2-5.5 5-5.5 9v7h11v-7c0-4-2-7-5.5-9z"/><circle cx="12" cy="9" r="2"/><path d="M9.5 15c.8 1 4.2 1 5 0"/>',
  prayinghands:
    '<path d="M11 20V9.5C11 7 10 5 8.5 4 8 6.5 8 9 8.5 11.5L11 20z"/><path d="M13 20V9.5C13 7 14 5 15.5 4c.5 2.5.5 5 0 7.5L13 20z"/>',
  rosary:
    '<circle cx="12" cy="10" r="6" stroke-dasharray="0.1 3"/><path d="M12 16v3M10.5 20.5h3"/>',
  doves:
    '<path d="M4 9c2-2 5-2 6.5.5C9 11 6 11 4 9z"/><path d="M10.5 9.5L13 7"/><path d="M13.5 14c2-2 5-2 6.5.5-1.5 1.5-4.5 1.5-6.5-.5z"/><path d="M20 14.5l2-2"/>',
  roses:
    '<circle cx="12" cy="8" r="2"/><path d="M12 6c1.5.5 2.5 2 2 3.5M12 10c-1.5-.5-2.5-2-2-3.5"/><path d="M12 10v9M12 14c-2 0-3-1-3.5-2.5M12 16c2 0 3-1 3.5-2.5"/>',
  flowers:
    '<circle cx="7" cy="8" r="1.6"/><circle cx="12" cy="6" r="1.6"/><circle cx="17" cy="8" r="1.6"/><path d="M7 9.6V19M12 7.6V19M17 9.6V19M5 19h14"/>',
  olive:
    '<path d="M5 19C9 15 14 9 19 5"/><ellipse cx="10" cy="12" rx="2.4" ry="1.2" transform="rotate(-45 10 12)"/><ellipse cx="14" cy="8" rx="2.4" ry="1.2" transform="rotate(45 14 8)"/><ellipse cx="14" cy="15" rx="2.4" ry="1.2" transform="rotate(45 14 15)"/>',
  butterflies:
    '<path d="M12 7v10"/><path d="M12 10C9 6 4 6 4 9.5S9 14 12 12"/><path d="M12 10c3-4 8-4 8-.5S15 14 12 12"/><path d="M10.5 6l1.5 1.5L13.5 6"/>',
  leaves:
    '<path d="M6 18C6 12 9 8 15 7c0 6-3 10-9 11z"/><path d="M6 18c3-4 6-7 9-9"/><path d="M15 17c2-.5 3.5-2 4-4-2 0-3.5.7-4.5 2"/>',
  candles:
    '<path d="M9 11v8h6v-8z"/><path d="M12 8.5c1.2-1.2 1.2-2.6 0-4-1.2 1.4-1.2 2.8 0 4z"/><path d="M12 8.5V11M6 19h12"/>',
  rays:
    '<path d="M4 19h16"/><path d="M12 15a4.5 4.5 0 014.5 4H7.5A4.5 4.5 0 0112 15z"/><path d="M12 12V8M8 13l-2.5-3M16 13l2.5-3M5.5 16.5L3 15M18.5 16.5L21 15"/>',
  stars:
    '<path d="M12 5l1.2 3.3L16.5 9.5l-3.3 1.2L12 14l-1.2-3.3L7.5 9.5l3.3-1.2z"/><path d="M18 15l.7 1.8 1.8.7-1.8.7L18 20l-.7-1.8-1.8-.7 1.8-.7z"/>',
  custom:
    '<path d="M5 19l1-4L16.5 4.5a1.8 1.8 0 012.5 0l.5.5a1.8 1.8 0 010 2.5L9 18z"/><path d="M14 7l3 3"/>',
};

export const elementIconSvg = (itemKey, { size = 22 } = {}) => {
  const inner = ELEMENT_ICONS[itemKey];
  if (!inner) {
    return '';
  }
  return `<svg class="ai-bgb-icon" viewBox="0 0 24 24" width="${size}" height="${size}" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${inner}</svg>`;
};
